import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "associated-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "assoicated-courses" */ "./components"),
      import(
        /* webpackChunkName: "assoicated-courses" */ "AssociatedCourses/modules/AssociatedCoursesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      const reducerName = importedModule1.NAME;

      injectReducer(store, {
        key: reducerName,
        reducer,
      });
      return component;
    })
  ),
});
